import { VtSettingsListGroupLink } from '@shared/interfaces/settings-list-group-link';
import { IntegrationSettingsRouteName } from './integration-settings.routes';

export const integrationsMenuItemTitle = 'Settings.Integration';

export const integrationsMenuItemLinks: VtSettingsListGroupLink[] = [
  // https://devinco.atlassian.net/browse/VW-2121
  // {
  //   label: 'Settings.Integration.VismaExpense',
  //   routerLink: IntegrationSettingsRouteName.VismaExpense,
  //   permissions: [RolesAndPermissions.IntegrationSettingsRead],
  // },
  {
    label: 'Settings.Integration.VippsIntegration',
    routerLink: IntegrationSettingsRouteName.VippsIntegration,
  },
];
